import axios from 'axios';
import {PetitionCampaignDTO} from "./types";
export function signAndOptionForms(campaign: PetitionCampaignDTO) {
    return {
        step: 1,
        offers_selected: 0,
        offers: [],
        signFormDisabled: false,
        optionsFormDisabled: false,
        sign_errors: false,
        messages: {
            // Sign errors
            first_name: '',
            last_name: '',
            email: '',
            comment: '',
            petition_updates_ok: '',
            platform_updates_ok: '',
            // Offer Support options errors
            skill_info: '',
            skill_info_public: '',
            organisation_contact_ok: '',
            postcode: '',
        },
        modal_open: false,
        window_observer: null,
        init() {
            // Ensure form is visible on desktop (ie when not a modal)
            this.window_observer = new ResizeObserver((entries) => {
                this.modal_open = entries[0].contentRect.width >= 976;
            });
            this.window_observer.observe(document.querySelector('.site-header'));
        },
        showModal() {
            this.modal_open = true;
        },
        hideModal() {
            this.modal_open = false;
        },
        signFormHandlers: {
            ['@submit'](e) {
                e.preventDefault();
                this.signFormDisabled = true;
                let form = e.target;
                let data = new FormData(form);
                let that = this;
                this.clearMessages();
                this.sign_errors = false;
                axios({
                    method: form.method,
                    url: form.action,
                    data: data,
                })
                    .then(function (response) {
                        //handle success
                        if (response.data.success) {
                            if (typeof gtag !== 'undefined') {
                                gtag('event', 'signed', {
                                    'event_label': campaign.petition.name,
                                    'event_category': 'petition'
                                });
                            }
                            if (response.data.step) {
                                that.step = response.data.step;
                            } else if (response.data.redirect_url) {
                                that.hideModal();
                                window.location.href = response.data.redirect_url;
                            } else {
                                console.error('unknown action');
                            }
                        }
                    })
                    .catch(function (error) {
                        //handle error
                        if (error.response && error.response.status === 422) {
                            // form validation
                            if (error.response.data.errors) {
                                that.setMessages(error.response.data.errors);
                                that.sign_errors = true;
                            }
                        }
                    })
                    .finally(() => {
                        this.signFormDisabled = false;
                    });
            }
        },
        commentHandlers: {
            ['@input'](e) {
                this.autoExpand(e.target);
            }
        },
        autoExpand(field) {
            // Reset field height
            field.style.height = 'inherit';

            // Get the computed styles for the element
            const computed = window.getComputedStyle(field);

            field.style.height = field.scrollHeight + 'px';
        },
        optionsFormHandlers: {
            ['@submit'](e) {
                e.preventDefault();
                this.optionsFormDisabled = true;
                let form = e.target;
                let data = new FormData(form);
                let that = this;
                this.clearMessages();
                axios({
                    method: form.method,
                    url: form.action,
                    data: data,
                })
                    .then(function (response) {
                        //handle success
                        if (response.data.success) {
                            if (typeof gtag !== 'undefined') {
                                gtag('event', 'support_offered', {
                                    'event_label': campaign.petition.name,
                                    'event_category': 'petition'
                                });
                            }
                            if (response.data.redirect_url) {
                                that.hideModal();
                                window.location.href = response.data.redirect_url;
                            } else {
                                console.error('unknown action');
                            }
                        }
                    })
                    .catch(function (error) {
                        //handle error
                        if (error.response && error.response.status === 422) {
                            // form validation
                            if (error.response.data.errors) {
                                that.setMessages(error.response.data.errors);
                            }
                        }
                    })
                    .finally(() => {
                        this.optionsFormDisabled = false;
                    });
            }
        },
        checkboxOffer: {
            ['@click'](e) {
                this.offers_selected += e.target.checked ? 1 : (this.offers_selected > 0 ? -1 : 0);
            }
        },
        clearMessages() {
            for (let property in this.messages) {
                this.messages[property] = '';
            }
        },
        clearMessage(name) {
            if (this.messages.hasOwnProperty(name)) {
                this.messages[name] = '';
            }
        },
        setMessages(errors) {
            for (let property in errors) {
                this.setMessage(property, errors[property][0]);
            }
        },
        setMessage(name, msg) {
            if (this.messages.hasOwnProperty(name)) {
                this.messages[name] = msg;
            }
        },
    };
}
